import { useField, useFormikContext } from 'formik'
import React from 'react'

import FieldError from '@/components/form/FieldError'
import FieldLabel, {
  ModalHint,
  TooltipHint,
} from '@/components/form/FieldLabel'
import { Checkbox } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'

interface Props {
  name: string
  label?: string | React.ReactNode
  labelWrapperClassName?: string
  labelClassName?: string
  tooltipHint?: TooltipHint
  modalHint?: ModalHint
  hideError?: boolean
  isDisabled?: boolean
  onChange?: (value: boolean) => void
}

const CheckboxInput: React.FC<Props> = ({
  name,
  label,
  labelWrapperClassName,
  labelClassName,
  tooltipHint,
  modalHint,
  hideError = false,
  isDisabled,
  onChange,
}) => {
  const { setFieldValue, submitCount } = useFormikContext()
  const [field, { error }] = useField(name)
  const id = `field_${name}`
  const showError = !hideError && !!(submitCount > 0 && error)

  return (
    <>
      <div className="flex items-start">
        <Checkbox
          id={id}
          {...field}
          checked={field.value}
          className="mt-0.5 mr-1.5 inline-block"
          disabled={isDisabled}
          onCheckedChange={(isChecked) => {
            setFieldValue(name, isChecked)

            if (onChange) {
              onChange(!!isChecked)
            }
          }}
        />

        {label && (
          <FieldLabel
            htmlFor={id}
            tooltipHint={tooltipHint}
            modalHint={modalHint}
            className={cn('mb-0', labelClassName)}
            wrapperClassName={labelWrapperClassName}
          >
            {label}
          </FieldLabel>
        )}
      </div>

      {showError && <FieldError inputId={id}>{error}</FieldError>}
    </>
  )
}

export default CheckboxInput
